/* @sravni/react-design-system version 0.2.65 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_211f87e9 from '../styles/Progress.module.less.js';

function validProgress(progress) {
    if (!progress || progress < 0) {
        return 0;
    }
    if (progress > 100) {
        return 100;
    }
    return progress;
}
/**
 * @description The progress component displays the length of a process
 *
 * @component
 * @example
 * ```jsx
 * <Progress percent={30} />
 * ```
 */
var Progress = React.forwardRef(function (props, ref) {
    var percent = props.percent, className = props.className, restProps = __rest(props, ["percent", "className"]);
    var cx = useStyles(modules_211f87e9);
    var classNames = cx(className, 'container');
    var percentStyle = {
        width: validProgress(percent) + "%",
    };
    return (React.createElement("div", __assign({ ref: ref, "data-qa": "Progress", className: classNames }, restProps),
        React.createElement("div", { className: cx('inner') },
            React.createElement("div", { className: cx('progress'), style: percentStyle }))));
});
Progress.defaultProps = {
    percent: 0,
};
Progress.displayName = 'Progress';

export default Progress;
//# sourceMappingURL=Progress.js.map
